import { Suspense, useEffect, useState, lazy } from 'react';
import { Spinner, Stack } from '@guestyci/arc';
import cookie from 'js-cookie';
import InstanceBanner from './InstanceBanner';
import { useOktaAuth } from '@okta/okta-react';
import {
  getSecureAuthCookie,
  fetchUserData,
  setDataDogUser,
} from '../../login/helpers';
import { saveUserPreferences } from 'utils/userPreferences';

import { utils } from 'utils';
import { getEnv } from 'utils/env';

const ErrorComponent = lazy(() => import('./SessionError'));

const SessionHandler = () => {
  const [error, setError] = useState(false);
  const { oktaAuth: authClient } = useOktaAuth();
  const searchParams = new URLSearchParams(window.location.search);
  const redirectTo = searchParams.get('redirectTo');

  useEffect(() => {
    const initAuthentication = async () => {
      try {
        const session = await authClient.session.get();
        if (session.status === 'INACTIVE') {
          console.log('Loading - Session inactive - Throwing');
          throw new Error('Session inactive');
        }
        window.localStorage.removeItem('token');

        const { tokens } = await authClient.token.getWithoutPrompt();
        console.log('Loading - Finished generating tokens.');
        authClient.tokenManager.setTokens(tokens);
        await getSecureAuthCookie();
        const user = await fetchUserData({ enrichUser: true });
        await setDataDogUser({ isInstance: true, user });
        console.log('Loading - Finished saving tokens.');
        if (tokens?.accessToken) {
          utils.saveUserData(tokens.accessToken.accessToken);
        }

        await saveUserPreferences({
          accessToken: tokens?.accessToken?.accessToken,
          preferences: user?.preferences,
        });

        cookie.remove('hq_inst_pdg', { domain: '.guesty.com' });
        const { dimension } = getEnv();
        if (dimension === 'app' && !tokens?.accessToken?.claims?.accountId) {
          throw new Error('missing account id');
        }

        if (redirectTo) {
          window.location.replace(redirectTo);
        } else {
          window.location.replace('/');
        }
      } catch (e) {
        console.error('Finish session handler with error - logout', e);
        setError(e);
      }
    };
    initAuthentication();
  }, [authClient, redirectTo]);

  if (error) {
    return (
      <Suspense fallback={null}>
        <ErrorComponent />;
      </Suspense>
    );
  }

  return (
    <Stack spacing={0} className="gst-min-h-screen gst-bg-white">
      <InstanceBanner />
      <Stack spacing={0} align="center" justify="center" className="gst-flex-1">
        <Spinner size="xl" className="gst-text-primary" />
      </Stack>
    </Stack>
  );
};

export default SessionHandler;
